//import Libraries
import * as firebase from 'firebase';

//import Components
// var config = {
//   apiKey: "AIzaSyCy7Stgv61C52ShzqA9VUx80B3nontX4dg",
//   authDomain: "dyweb-prac.firebaseapp.com",
//   databaseURL: "https://dyweb-prac.firebaseio.com",
//   projectId: "dyweb-prac",
//   storageBucket: "dyweb-prac.appspot.com",
//   messagingSenderId: "315014841221"
// };
// firebase.initializeApp(config);
var config = {
  apiKey: "AIzaSyBevFWe7VlYBdEHZjMjg6SFuHF4UmQrm60",
  authDomain: "dygs-homepage.firebaseapp.com",
  databaseURL: "https://dygs-homepage.firebaseio.com",
  projectId: "dygs-homepage",
  storageBucket: "dygs-homepage.appspot.com",
  messagingSenderId: "1032097645495"
};
firebase.initializeApp(config);

const database = firebase.database();
const storageRef = firebase.storage().ref();

export {database, storageRef};


// WEBPACK FOOTER //
// ./src/firebase.js